/**
 * Organizacion
 *
 */
import React from 'react'
import Api from '../Api'
import Exception from '../Exception'

/**
 * loadOrgInfo
 */
export const loadOrgInfo = () =>
  Api.query({
    __returnType: 'one',
    model: 'KernelOrganizacion',
    attributes: [
      ['nombreorganizacion', 'nombre'],
      ['sProveedoresOpciones', 'opciones'],
    ],
  })

const defaultInfo = {
  nombre: 'Cargando...',
  opciones: undefined,
}

/**
 * Context
 */
export const OrgContext = React.createContext({
  ...defaultInfo,
})

export const OrgConsumer = OrgContext.Consumer

/**
 * Component
 *
 */
export class Organizacion extends React.Component {
  state = {...defaultInfo}

  /**
   * componentDidMount
   */
  componentDidMount() {
    loadOrgInfo()
      .then(({ data: org }) => {
        const titles = document.head.getElementsByTagName('title')
        if (titles.length) {
          titles[0].text = org.nombre
        } else {
          const title = document.createElement('title')
          title.text = org.nombre
          document.head.appendChild(title)
        }

        this.setState({
          ...defaultInfo,
          ...org
        })
      })
      .catch(error => {
        Exception.load(error).show()
      })
  }

  render() {
    return (
      <OrgContext.Provider value={this.state}>
        {this.props.children}
      </OrgContext.Provider>
    )
  }
}
